import {Grid, Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import AurCountryFlag from '../../../../common/aur-country-flag/AurCountryFlag';
import {ServiceAgreementProps} from '../../components/AurServiceAgreementDropdown';

const agreementStringPath =
  'projectCreation.serviceAgreementSelectionPage.serviceAgreementCard.';

const InfoItem: React.FC<{
  label: string;
  value: React.ReactNode;
  classNames?: string;
}> = ({label, value, classNames}) => (
  <Grid item xs={12} sm={6} className={classNames}>
    <Typography className="typo-text label2_size service-agreement-item-title">
      {label}
    </Typography>
    <Typography className="typo-text subhead3_size service-agreement-item-value">
      {value}
    </Typography>
  </Grid>
);
interface BillingAgreementDetailsProps {
  agreement?: ServiceAgreementProps;
}

export const BillingAgreementDetails: React.FC<
  BillingAgreementDetailsProps
> = ({agreement}) => {
  if (!agreement) return null;

  const {
    engagementName,
    engagementCode,
    geography,
    countryName,
    serviceType,
    engagementType: agreementType,
    eciAccessEnabled,
    reviewPlatform,
  } = agreement;

  return (
    <div className="billing-agreement-popup-content">
      <div className="billing-agreement-header">
        <Typography className="typo-text label2_size service-agreement-item-title">
          {t('projectCreation.creation.infoForm.agreement')}
        </Typography>

        <div className="billing-agreement-item-content">
          <Typography className="typo-text subhead4_size">
            {`[${engagementName}] - ${
              engagementCode ? `${engagementCode}` : ''
            }`}
          </Typography>
        </div>
      </div>

      <Grid container spacing={4}>
        <InfoItem
          label={t(agreementStringPath + 'type')}
          value={agreementType}
        />

        <InfoItem
          label={t(agreementStringPath + 'eci')}
          value={t(
            `projectCreation.common.${eciAccessEnabled ? 'enabled' : 'disabled'}`
          )}
        />

        <InfoItem
          classNames=""
          label={t(agreementStringPath + 'review')}
          value={reviewPlatform}
        />

        <InfoItem
          classNames=""
          label={t(agreementStringPath + 'geography')}
          value={
            <>
              <span aria-label={countryName} className="country-flag">
                <AurCountryFlag countryCode={geography} altText={countryName} />
              </span>
              {countryName}
            </>
          }
        />

        <InfoItem
          classNames=""
          label={t(agreementStringPath + 'projectServiceType')}
          value={serviceType}
        />
      </Grid>
    </div>
  );
};

export default BillingAgreementDetails;
